import React from 'react'
import {connect} from "react-redux";
import {actions} from "../../actions";
import {ROLES, withRoles} from "../Permissions";
import {withStyles} from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button";

const styles = theme => ({
    commentField: {
        width:'100%',
        marginBottom:'5px'
    },
    commentForm:{
        width:'100%'
    },
    buttonGroup:{
        textAlign:'right'
    },
    cancelButton: {
        marginRight:'5px'
    },
    commentCard:{
        width:'100%'
    }
});

class CommentForm extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            comment:'',
            isExpanded:false
        }
    }

    handleFieldChange = e =>{
        this.setState({
            comment:e.target.value
        })
    }

    handleAddComment=e=>{
        e.preventDefault();
        const comment = this.state.comment;
        this.props.addComment(comment);
        this.setState({
            comment:'',
        })
    }

    handleCancelComment=e=>{
        this.setState({
            comment:'',
            isExpanded:false
        })
    }


    render(){
        return(
            <div>
                <form method="post" onSubmit={this.handleAddComment} className={this.props.classes.commentForm}>
                    <div className="form-group">
                        <TextField
                            id="filled-multiline-flexible"
                            label="Add Comment"
                            multiline
                            rowsMax={4}
                            value={this.state.comment}
                            onChange={this.handleFieldChange}
                            variant="outlined"
                            className={this.props.classes.commentField}
                        />
                    </div>

                    <div className="form-group" className={this.props.classes.buttonGroup}>
                        <Button variant = 'contained' color = 'secondary'  className={this.props.classes.cancelButton} onClick = {this.handleCancelComment} size = 'small'>
                            Cancel
                        </Button>
                        <Button variant = 'contained' color = 'secondary'  disabled={this.state.comment.length<1} onClick = {this.handleAddComment} size = 'small'>
                            Save
                        </Button>
                    </div>
                </form>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        reviewers: state.reviewers,
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRoles([ROLES.REVIEWER])(CommentForm)));
